// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { MobilePosition_abstract } from './../abstract/SagaBase/MobilePosition_abstract';
export class MobilePosition extends MobilePosition_abstract {}
